/**
 * 应用启动时加载内容包，解码校验后提供 ContentRepository。
 * 加载失败时抛出，由根组件展示错误状态。
 */

import { useEffect, useState } from 'react';
import { loadRepository, type ContentRepository } from '@/core/contentRepository';

interface UseRepositoryResult {
  repository: ContentRepository | null;
  loading: boolean;
  error: Error | null;
}

// vite 以 /public 为根，base path 已处理。开发与生产一致。
const CONTENT_URL = `${import.meta.env.BASE_URL}encyclopedia.json`;

export function useRepository(): UseRepositoryResult {
  const [state, setState] = useState<UseRepositoryResult>({
    repository: null,
    loading: true,
    error: null,
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const response = await fetch(CONTENT_URL, { cache: 'no-cache' });
        if (!response.ok) {
          throw new Error(`加载内容包失败：HTTP ${response.status}`);
        }
        const raw = await response.json();
        const repository = loadRepository(raw);
        if (!cancelled) setState({ repository, loading: false, error: null });
      } catch (err) {
        if (!cancelled) {
          setState({
            repository: null,
            loading: false,
            error: err instanceof Error ? err : new Error(String(err)),
          });
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
